import { render } from "./DefectEdit.vue?vue&type=template&id=170c0cd9"
import script from "./DefectEdit.vue?vue&type=script&lang=js"
export * from "./DefectEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__